import "core-js/stable";
import "regenerator-runtime/runtime";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Draggable } from "gsap/Draggable";
import { TextPlugin } from "gsap/TextPlugin";
import { InertiaPlugin } from "gsap/all";

import { AubadeBootstrap } from "./bootstrap/AubadeBootstrap";
import * as Components from "./components";
import { Env, AjaxPageModule } from "libs";

import { customization } from "./storage";

//Gsap default params
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(Draggable);
gsap.registerPlugin(InertiaPlugin);
gsap.registerPlugin(TextPlugin);
gsap.config({ force3D: true });
gsap.defaults({ ease: "none", duration: 0.4 });

// Add notouch class
if (!Env.device.touch) document.querySelector("html").classList.add("notouch");
//Initialize bootstrap
const bootstrap = new AubadeBootstrap();
bootstrap.components.register(Components);

const ajaxPageModule = bootstrap.get(AjaxPageModule);
//Fetch the first child of the #root node
ajaxPageModule.transform = async dom => {
    dom.style.setProperty("visibility", "hidden");
    return dom;
};

let viewport = bootstrap.viewport;
viewport.add({
    addClass: false,
    name: "mobile",
    maxWidth: 375
});
viewport.add({
    name: "tablet",
    minWidth: 768,
    maxWidth: 1280
});
viewport.add({
    name: "desktop",
    minWidth: 1280
});

viewport.add({
    name: "landscape",
    minWidth: 1010,
    maxWidth: 1280
});

viewport.add({
    name: "large",
    minWidth: 1600
});

viewport.add({
    name: "verylarge",
    minWidth: 1920
});

viewport.on("resize", () => {
    document.body.style.setProperty("--vh", window.innerHeight / 100 + "px");
});

bootstrap.run();

window["bootstrap"] = bootstrap;
export default bootstrap;
